/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_result_tip = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tip amount`)
};

const es_pct_result_tip = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importe de la propina`)
};

const de_pct_result_tip = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trinkgeldbetrag`)
};

const nl_pct_result_tip = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fooibedrag`)
};

const fr_pct_result_tip = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montant du pourboire`)
};

const it_pct_result_tip = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importo della mancia`)
};

const pt_br2_pct_result_tip = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor da gorjeta`)
};

const pt_pct_result_tip = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor da gorjeta`)
};

const ja_pct_result_tip = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チップ額`)
};

const zh_pct_result_tip = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`小费金额`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_result_tip = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_result_tip(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_result_tip", locale)
	if (locale === "en") return en_pct_result_tip(inputs)
	if (locale === "es") return es_pct_result_tip(inputs)
	if (locale === "de") return de_pct_result_tip(inputs)
	if (locale === "nl") return nl_pct_result_tip(inputs)
	if (locale === "fr") return fr_pct_result_tip(inputs)
	if (locale === "it") return it_pct_result_tip(inputs)
	if (locale === "pt-BR") return pt_br2_pct_result_tip(inputs)
	if (locale === "pt") return pt_pct_result_tip(inputs)
	if (locale === "ja") return ja_pct_result_tip(inputs)
	return zh_pct_result_tip(inputs)
};